import {TextAnimations} from "./text-animation";
import {ImageReveal} from "./image-reveal";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', () => {
    const footerIncentive = document.querySelector('.mksun-layout-footer__incentives');
    if (footerIncentive) {
        const TextAnimationFooterIncentive = new TextAnimations([
            {
                selector: '.mksun-layout-footer__incentives h2',
                type: 'words',
                position: '>'
            }
        ], footerIncentive, {}, {start: "top 50%"});

        TextAnimationFooterIncentive.init();

        TextAnimationFooterIncentive.timeLine.from(
            '.mksun-layout-footer__incentives',
            {
                background: "transparent",
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }
        )

        TextAnimationFooterIncentive.animate();

        TextAnimationFooterIncentive.timeLine.from(
            '.mksun-layout-footer__incentives__ctn__card',
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }, "="
        )

        TextAnimationFooterIncentive.timeLine.from(".mksun-layout-footer__incentives__credit-card",
            {
                x: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out'
            }, ">"
        )
    }

    const footerMain = document.querySelector('.mksun-layout-footer__footer');
    if (footerMain) {
        const TextAnimationFooterMain = new TextAnimations([
            {
                selector: '.mksun-layout-footer__footer h2',
                type: 'words',
                position: '>'
            }
        ], footerMain, {}, {start: "top 50%"});

        TextAnimationFooterMain.init();

        /*TextAnimationFooterMain.timeLine.from(
            '.mksun-layout-footer__footer',
            {
                background: "transparent",
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }
        )*/

        TextAnimationFooterMain.animate();

        TextAnimationFooterMain.timeLine.from(".mksun-layout-footer__footer__ctn__newsletter__form",
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out'
            }, "=")

        const listsFooter = document.querySelectorAll(".mksun-layout-footer__footer__ctn__site-map h3, .mksun-layout-footer__footer__ctn__site-map li, .mksun-layout-footer__footer__ctn__about h3, .mksun-layout-footer__footer__ctn__about li");

        console.log(listsFooter);

        TextAnimationFooterMain.timeLine.from(listsFooter,
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }, "<")

        TextAnimationFooterMain.timeLine.from(".mksun-layout-footer__footer__ctn__logo-bottom",
            {
                opacity: 0,
                y: 24,
                duration: .5,
                ease: 'power1.out'
            }, ">")
    }
})